module.exports = __webpack_public_path__ + "img/iluy.1e575495.png";